'use strict';

require('../../models/user/userRelation');

angular.module('far.helpers.users', [
    'far.models.userRelation'
])
    .filter('userType', function () {
        return function (users, userType) {
            return users.filter(function (user) {
                return user[user.relation].id == userType.id;
            });
        };
    })
    .service('usersHelper', function (UserRelation) {
        var addUsersRelation = function (model, usersRelation) {
            Object.defineProperty(model, '_usersRelation', {
                enumerable: false,
                writable: false,
                value: usersRelation
            });
        }
        var addUsersArray = function (model, usersArrayProperty) {
            Object.defineProperty(model, '_usersArray', {
                enumerable: false,
                writable: false,
                value: usersArrayProperty
            });
        };
        var addUserTypes = function (model, userTypes) {
            Object.defineProperty(model, 'userTypes', {
                enumerable: false,
                writable: false,
                value: userTypes
            });
        };
        var addCreateUserFunc = function (model, usersArrayProperty) {
            Object.defineProperty(model, 'createUser', {
                enumerable: false,
                writable: false,
                value: function (userType) {
                    var newUndefinedUser = UserRelation.newUndefined(model._usersRelation, userType);
                    this[usersArrayProperty].push(newUndefinedUser);

                    return newUndefinedUser;
                }
            });
        };
        var addUpdateUsersFunc = function (model, usersArrayProperty) {
            Object.defineProperty(model, 'updateUsers', {
                enumerable: false,
                writable: false,
                value: function () {
                    this[usersArrayProperty] = this[usersArrayProperty].map(function (user) {
                        return UserRelation.new(user);
                    });
                }
            });
        };
        var addUpdateUserFunc = function (model, usersArrayProperty) {
            Object.defineProperty(model, 'updateUser', {
                enumerable: false,
                writable: false,
                value: function (uniqId, newUserData) {
                    this[usersArrayProperty].filter(function (user) {
                        return user.uniqId == uniqId;
                    })[0].user = angular.isObject(newUserData) ? newUserData : undefined;
                }
            });
        };
        var addDeleteUserFunc = function (model, usersArrayProperty) {
            Object.defineProperty(model, 'deleteUser', {
                enumerable: false,
                writable: false,
                value: function (deleteUser) {
                    this[usersArrayProperty] = this[usersArrayProperty].filter(function (user) {
                        return user.uniqId != deleteUser.uniqId;
                    });
                }
            });
        };

        this.addFields = function (model, userTypes, usersArrayProperty, usersRelation) {
            addUsersRelation(model, usersRelation);
            addUserTypes(model, userTypes);
            addUsersArray(model, usersArrayProperty);
            addCreateUserFunc(model, usersArrayProperty);
            addUpdateUsersFunc(model, usersArrayProperty);
            addUpdateUserFunc(model, usersArrayProperty);
            addDeleteUserFunc(model, usersArrayProperty);
        };

        this.initUsers = function (model, userTypes, usersArrayProperty, usersRelation) {
            this.addFields(model, userTypes, usersArrayProperty, usersRelation);

            model[usersArrayProperty] = model[usersArrayProperty].map(function (user) {
                return UserRelation.new(user);
            });
        };

    });
